import React from 'react'

import epulLogo from '../assets/epul-logo-footer.png'
import securecode_frame from '../assets/MasterCard_SecureCode.svg'
import pciLogo from '../assets/pci-logo.svg'
import thawte_frame from '../assets/Thawte.svg'
import verified_visa_frame from '../assets/VbyV_en_2c.svg'
// import yigimLogo from '../assets/yigim-logo.svg'

const Footer = ({ containerClassName }) => {
  return (
    <footer className='footer'>
      <div className={containerClassName}>
        <div className='footer_inner'>
          <ul className='footer_logos'>
            {/* <li>
              <img src={epulLogo} alt='' />
            </li> */}
            {/* <li>
              <img src={yigimLogo} alt='' />
            </li> */}
            <li>
              <img src={thawte_frame} alt='' />
            </li>
            <li>
              <img src={securecode_frame} alt='' />
            </li>
            <li>
              <img src={verified_visa_frame} alt='' />
            </li>
            <li>
              <img src={pciLogo} alt='' />
            </li>
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default Footer
